import React from 'react';
import { Switch } from 'react-router-dom';
import defaultProps from 'recompose/defaultProps.js';
import { Route, NotFound } from 'cccisd-laravel-boilerplate';
import { AdminRoutes, Manage as AppdefManage } from 'cccisd-laravel-appdefs';
import { Quest } from 'cccisd-laravel-assignment';
import { AuthRedirect } from 'cccisd-laravel-nexus';

// Layouts
import MainLayout from './layouts/MainLayout';
import QuestLayout from './layouts/QuestLayout';

// Pages
/* eslint-disable import/no-extraneous-dependencies, import/no-unresolved */
import Welcome from './pages/Welcome'; // Include it into main bundle

// Laravel packages
import Nexus from 'bundle-loader?lazy!cccisd-laravel-nexus';

// Components
import SupportRedirect from './components/SupportRedirect';
import StyledResourceCenter from './components/StyledResourceCenter';

// Bind MainLayout by default
const AppRoute = defaultProps({ layout: MainLayout })(Route);

const MainLayoutFluid = defaultProps({ className: 'container-fluid' })(MainLayout);
const MainLayoutSecondaryNav = defaultProps({ showSecondaryNav: true })(MainLayout);
const MainLayoutFluidSecondaryNav = defaultProps({
    className: 'container-fluid',
    showSecondaryNav: true,
})(MainLayout);

let Fortress = window.cccisd.fortress;
let AppDefinitions = window.cccisd.appDefs;

const componentMatch = {
    AppdefManage,
    Welcome,
};

const layoutMatch = {
    MainLayout,
    MainLayoutFluid,
    MainLayoutSecondaryNav,
    MainLayoutFluidSecondaryNav,
};

export default () => (
    <Switch>
        {AppDefinitions.routes.map(route => {
            const Component = componentMatch[route.componentHandle];
            if (!Component) {
                return null;
            }

            return (
                <AppRoute
                    key={route.handle}
                    path={route.url}
                    component={Component}
                    componentProps={route.componentProps}
                    exact
                    layout={
                        'layout' in route && layoutMatch[route.layout] ? layoutMatch[route.layout] : MainLayoutFluid
                    }
                />
            );
        })}
        <AppRoute path="/" component={SupportRedirect} exact />
        <AppRoute path="/welcome" component={Welcome} />
        <AppRoute path="/support/:tab?/:id?" component={StyledResourceCenter} componentProps={{ handle: 'default' }} />
        <AppRoute
            path={['/quest/preview', '/d', '/survey']}
            component={Quest}
            componentProps={{
                errorLayout: MainLayout,
            }}
            layout={QuestLayout}
        />
        {/* Laravel packages routes */}
        {AdminRoutes(MainLayoutFluid)}
        <AppRoute path="/account" component={Nexus} />
        <AppRoute path={Fortress.settings.config.after_login_url} component={AuthRedirect} exact />
        {Fortress.auth() && <AppRoute path="/login" component={SupportRedirect} exact />}

        <AppRoute component={NotFound} />
    </Switch>
);
